import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import React from "react"

export default class AssignTo extends React.Component<any, any>{
    private info: AdditionalForwardingInfo;

    constructor(props) {
        super(props)
        this.info = this.props.entity.AdditionalForwardingInfo;
    }

    private onClick = (login: string) => {
        General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, { cmd: "assignTo", login: login })
    }

    private renderLabel = (login: string, text: string) => {
        if (Helper.isNullOrEmpty(login)) {
            return null;
        }
        return (
            <div style={{ marginLeft: "8px", fontSize: "0.85em" }} >
                <a onClick={() => { this.onClick(login) }} >{text}</a>
            </div>
            );
    }

    render() {
        const { LastEditorLogin, UserLogin, LastEditorName, CreateLogin, CreateName } = this.info;
        const showForwardToLastEditor = this.props.entity.Hotliner_Key.toLowerCase() != `{Benutzer}_${LastEditorLogin}`.toLowerCase();
        return (
            <div style={{ margin: "5px 0 0 0", display: "flex", fontSize: "12px" }} >
                {this.renderLabel(UserLogin, Helper.getTranslation("Field.Vorgang.ForwardToMe"))}
                {showForwardToLastEditor ? this.renderLabel(LastEditorLogin, Helper.getTranslation("Field.Vorgang.ForwardToLastEditor").replace("{name}", LastEditorName)) : null}
                {this.renderLabel(CreateLogin, Helper.getTranslation("Field.Vorgang.ForwardToAuthor").replace("{name}", CreateName))}
            </div>
        );
    }
}
interface AdditionalForwardingInfo {
    CreateLogin: string;
    CreateName: string;
    LastEditorLogin: string;
    LastEditorName: string;
    UserLogin: string;
    UserName: string;
}